var scope_0 = require('/Users/keremkazan/Documents/projects/uniform-graphql/docs-src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d48f97d0abd14129a37d7068afd540e.js').default;
var scope_1 = require('/Users/keremkazan/Documents/projects/uniform-graphql/docs-src/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;export default
        Object.assign({}, scope_0,
scope_1 )
    